export enum REMOVE_PARAMS_CONDITIONS {
    AllFiltersAndQueryExceptCompanies = "all filters and query except companies",
    AllFiltersExceptCompanies = "all filters except companies",
    AllForRootCompanyChange = "all for root company change",
    OnlyCompanies = "only companies"
}
